document.addEventListener("DOMContentLoaded", function () {
    function updateTotal() {
        let total = 0;
        let selectedCount = 0;
         let checkedCheckboxes = document.querySelectorAll(".custIn:checked");       
         checkedCheckboxes.forEach(function (checkbox) {
          let price = checkbox.getAttribute("data-v-price");         
          if (price) {
              total += parseInt(price);
              selectedCount++;
          }
      });
        document.querySelector(".totals__total-value strong").innerHTML = "₹ " + (total / 100).toLocaleString("en-US");
        document.getElementById("but_it_with").innerHTML = `ADD ${selectedCount} ITEM${selectedCount > 1 ? 'S' : ''} TO CART`;
        let existingError = document.getElementById("error-message");
          if (selectedCount > 0 && existingError) {
              existingError.remove();
          }
    }
    
    document.querySelectorAll(".custIn").forEach(function (checkbox) {
        checkbox.addEventListener("change", updateTotal);
    });    
    updateTotal();    
    document.getElementById("but_it_with").addEventListener("click", function () {
        let button = this;
        button.innerHTML = "Adding To Cart";
        let productsToAdd = [];
        
        let isAnyCheckboxSelected = false;
        document.querySelectorAll(".custIn:checked").forEach(function (checkbox) {
            let productId = checkbox.getAttribute("v_id");
            
            if (productId) {
                isAnyCheckboxSelected = true;
                productsToAdd.push({
                    id: productId,
                    quantity: 1
                });
            }
        });
        
        if (!isAnyCheckboxSelected) {
            console.log("Please check at least one item.");
            let errorMessage = document.createElement("div");
            errorMessage.id = "error-message";
            errorMessage.style.color = "red";
            errorMessage.style.marginBottom = "10px";
            errorMessage.style.fontSize = "10px";
            errorMessage.innerHTML = "Please select at least one product before adding to cart.";
            button.parentNode.insertBefore(errorMessage, button);
            button.innerHTML = "Add to Cart";
            return;
        }
        
        fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: productsToAdd })
        })
        .then(response => response.json())
        .then(data => {            
            setTimeout(() => { window.location.assign("/cart"); }, 2000);
        })
        .catch(error => {
            console.log("Error adding products to cart:", error);
            button.innerHTML = "Add to Cart";
        });
    });
});